export default __webpack_public_path__ + "static/O0253-f44ab5756be92fa52cc1b90fa6850195.png";